export default __webpack_public_path__ + "static/media/FAQ.7eb68657.pdf";